import React, { useState ,useEffect} from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { InputBaseField } from '../../../../components/InputField/InputField';
import { formateMdnNumber, validatePhoneNumber } from '../../../../components/Common/Extensions';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";

function SuspendPhoneNumber({ dialogOpenClose, handleClose,handleSuccessClose,fromDashboard, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ zipCode: '', mdnNumber: formateMdnNumber(props.mdnNumber) });
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [emailAddress, setEmailAddress] = useState(props.emailAddress);
    const [userName, setUserName] = useState(props.userName);
    const [errorMessages, setErrorMessages] = useState({
        errorZipCode: false, errorZipCodeLength: false
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    //action dialog 
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }

    const suspendMDN = () => {
        let errorList = [];
        if (!state.mdnNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
        if (state.mdnNumber && !validatePhoneNumber(state.mdnNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }
        if (errorList.length < 1) {
            showActionDialog("Are you sure you want to suspend this line?", "confirm", function () {
                var obj = {
                    MDN: state.mdnNumber,
                    userName: userName,
                    emailAddress: emailAddress,
                    accountNumber: accountNumber,
                    loginUserName: props.loginUserName,
                };
                setIsLoading(true)
                PostDataAPI("telispire/suspendLineByMDN", obj, true).then((result) => {
                    setIsLoading(false)
                    if (result.success && result.data != null) {
                        handleSuccessClose("Line suspended successfully");
                    } else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                })


            });
        }
       
        
        
    }

    useEffect(() => {
        console.log(props)
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                        <Typography className={classes.title}>Suspend/Deactivate Phone Number</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                    </div>
                    
                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                
                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Label size={12} title={fromDashboard?'Enter phone number:': 'Phone Number:'} mandatory={true} />
                                </Grid>
                                <Grid item lg={12}>
                                    <Grid item lg={12}>
                                        <InputBaseField
                                            id="mdnNumber"
                                            name="mdnNumber"
                                            value={state.mdnNumber}
                                            type="text"
                                            onChange={handlePhoneChange}
                                            placeholder='Phone number'
                                            IsDisabled={fromDashboard?false:true}
                                            MaxLength={14}
                                        />
                                        {errorMessages.errorPhone && !state.mdnNumber ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter phone number
                                        </FormHelperText>) : ('')}
                                        {errorMessages.errorInvalidPhone && state.mdnNumber && !validatePhoneNumber(state.mdnNumber) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid phone number
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                            </Grid>
                       
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {isLoading ?
                                <Button className={classes.changeBtn}>Suspend/Deactivate</Button>
                                :
                                <Button className={classes.changeBtn}
                                    onClick={suspendMDN}>Suspend/Deactivate</Button>
                            }
                            

                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </Dialog >
    )
}
export default withSnackbar(SuspendPhoneNumber);